<template>
  <div class="red-add-cart">
    <template v-if="count === 0">
      <hot-spot @btnClick="catchPlusTap" />
      <template v-if="promoteStyle">
        <img
          src="@/images/goods_rank/promote_red.png"
          class="operate-wrapper-promote"
        />
      </template>
      <btn-config
        v-else
        :width="buttonWidth"
        :height="buttonSize"
        :bg-color="'#F03100'"
        has-background
        :text="text"
        :icon-name="useIcon ? 'jiahaobai' : ''"
        :icon-size="'16px'"
        :font-size="fontSize"
        :border-radius="0.12"
      />
    </template>

    <div v-else class="visual has-count">
      <div class="sub" :style="{ width: plusMinusBtnWidth + 'rem' }">
        <hot-spot :right="0" @btnClick="catchMinusTap" />

        <img src="@/images/goods_rank/min_img_gray.png" class="add-img" />
      </div>
      <div class="num" @click.stop="keyboardTap">
        {{ count }}
      </div>
      <div class="add" :style="{ width: plusMinusBtnWidth + 'rem' }">
        <hot-spot :left="0" @btnClick="catchPlusTap" />
        <img src="@/images/goods_rank/add_img_gray.png" class="add-img" />
      </div>
    </div>
  </div>
</template>

<script>
import HotSpot from './hotSpot'
import BtnConfig from './btnConfig'
import { NEW_ADD_CART_STEP } from '@/defines/const'
import { THEME_COLOR } from '@/defines/environment/config'
export default {
  name: 'RedAddCart',
  components: {
    BtnConfig,
    HotSpot
  },
  props: {
    statusRemindInfo: {
      type: Object,
      default: () => {}
    },
    canBuy: {
      type: Boolean,
      default: false
    },
    promoteStyle: {
      type: Boolean,
      default: false
    },
    useIcon: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 0
    },
    btnWidth: {
      type: [Number, String],
      default: 0.52
    },
    compact: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    addStepType: {
      type: String,
      default: 'normal'
    },
    bgStartColor: {
      type: String,
      default: ''
    },
    bgEndColor: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    },
    fontSize: {
      type: Number,
      default: 0.26 // 13px=>0.26rem
    }
  },
  data() {
    return {
      THEME_COLOR
    }
  },
  computed: {
    buttonWidth() {
      return this.compact ? 0.56 : this.btnWidth
    },
    buttonSize() {
      return this.compact ? 0.56 : 0.64
    },
    plusMinusBtnWidth() {
      const stepType = NEW_ADD_CART_STEP[this.addStepType]
      return stepType.plusMinusBtnWidth
    }
  },
  methods: {
    catchMinusTap() {
      this.$emit('sub')
    },
    catchPlusTap() {
      this.$emit('add')
    },
    keyboardTap() {
      this.$emit('keyboard')
    }
  }
}
</script>

<style lang="scss" scoped>
.red-add-cart {
  position: relative;

  height: 0.56rem /* 28/50 */;

  @include flex-row-center;

  .visual {
    height: 0.56rem /* 28/50 */;

    background-color: #fff;

    flex: none;
    @include flex(row, flex-start, center, nowrap);
    .sub,
    .num,
    .add {
      position: relative;

      height: 0.56rem /* 28/50 */;

      text-align: center;
      @include flex-column-center;
    }
    .num {
      width: 0.5rem /* 25/50 */;
      font-size: 0.3rem /* 15/50 */;
      font-weight: bold;
      color: #262626;
      @include flex-row-center;
      &:after {
        display: block;

        position: absolute;
        top: -0.16rem;
        right: 0;
        bottom: -0.16rem;
        left: 0;

        content: '';
      }
    }
  }
}
.operate-wrapper-promote {
  width: 76px;
  height: 32px;
  font-size: 0;
  display: block;
}

.add-img {
  width: 28px;
  height: 28px;
  flex: none;
  position: relative;
  @include flex-column-center;
  font-size: 0;
}
</style>
